import { useEffect, useState } from "react";
import { useAuth } from "../Auth/store";

import dayjs from 'dayjs';
import locale from 'antd/es/date-picker/locale/ru_RU';

import { Table, Tag, Popover, DatePicker, Button, Checkbox, Select, Radio, Space } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';

import References from '../../helpers/Reference';
import { getStateInfo, getDangerLevelInfo, round, getDangersList, getMchsList } from '../../helpers/helpers';

import { loadEvent, ShowLocaleDateTime } from "../../helpers/helpers";

const CONTAINER_OTHER_ELEMS_HEIGHT = 300;

const escaladeOptions = [
	{label: References.dictionary.all, value: 0},
	{label: References.dictionary.escalade, value: 1},
	{label: References.dictionary.deescalade, value: 2},
];

const defEscaladeOption = 0;
const EVENT_DAY_PERIOD = 1

export const Events = ({station, container_height, onHelpContextClick}) => {

	const [ loaded, setLoaded ] = useState( false );
	const [ expired, setExpired ] = useState( false );

	const [ events, setEvents ] = useState([]);
	const [ start, setStart ] = useState(dayjs().subtract(1, 'day').endOf('hour').add(1, 'second'));
	const [ finish, setFinish ] = useState( dayjs().endOf('hour').add(1, 'second') );

    const [ selectedDangers, setSelectedDangers ] = useState([]);
    const [ selectedMchsTypes, setSelectedMchsTypes ] = useState([]);
	const [ filterNODATA ,setFilterNODATA] = useState( false );
	const [ filterEscalade, setFilterEscalade ] = useState( defEscaladeOption )

	const [ containerHeight, setContainerHeight ] = useState( container_height );

    const {permission} = useAuth();
	
	const load = () => {
		setLoaded(false);
		const stationValue = station.uuid;
		loadEvent({start, finish, stationValue, selectedDangers, selectedMchsTypes, filterNODATA, filterEscalade})
			.then(data => {
				setEvents(data?.events);
				setLoaded( true );
				setExpired( false );
			});
	}

    useEffect(() => {
		if (permission.permissions.can_view_event_data) {
			load();
		}
    }, 
    [ station ]);

	useEffect(() => {
		setContainerHeight(container_height);
	},
	[container_height]);

	const onStartOk = ( value ) => {
		setStart( (value) );
		setExpired(true);
	}

	const onFinishOk = ( value ) => {
		setFinish( (value) );
		setExpired(true);		
	}

	const onChangeFilterNODATA = ( e ) => {
		setFilterNODATA( e.target.checked );
		setExpired(true);		
	}

	const onChangeFilterEscalade = ( e ) => {
		setFilterEscalade( e.target.value );		
		setExpired(true);		
	}

	const onChangeSelectedDangers = ( items ) => {
		setSelectedDangers( items );
		setExpired( true );
	}

	const onChangeSelectedMchsTypes = ( items ) => {
		setSelectedMchsTypes( items );
		setExpired( true );
	}

	const onShowEventBtnClick = () => {
		load();
	}

	const getValue = ( value, mchsType ) => {
		if (value) {
			if (References.mchs.hasOwnProperty(mchsType)) {
				let mchsInfo = References.mchs[mchsType];
				if (value.hasOwnProperty(mchsInfo.field))
					return round( value[mchsInfo.field], mchsInfo.precision );
			}
		}
	}

    const eventsData = ( events ) => {
		return events.map((item, index) => {			

			let stateStart = getStateInfo(item.state_code_from, item.mchs.type);
			let stateFinish = getStateInfo(item.state_code_to, item.mchs.type);
			let dangerInfo = getDangerLevelInfo(item.danger_level_code);

			return {
				key: 'events_table_row' + index,
				station_uuid: item.station.uuid,
				station_short_name: item.station.short_name, 
				mchs_uuid: item.mchs.uuid,
				mchs_type: item.mchs.type,
				mchs_name: item.mchs.name,
				danger_level: dangerInfo,
				state_start_short: stateStart['short'],
				start_start_full: stateStart['title'],
				state_finish_short: stateFinish['short'],
				state_finish_full: stateFinish['title'],
				danger_level_short: dangerInfo['short'],
				danger_level_full: dangerInfo['title'],
				value: getValue( item.value, item.mchs.type ),
				state_change_date: ShowLocaleDateTime(new Date(item.time))
			};
    	})
	}

	const columns = [
	    {
	        title: 'Канал',
	        dataIndex: 'mchs_name',
	        key: 'event_table_header_mchs'

	    },
	    {
	        title: 'Исходное',
	        dataIndex: 'state_start_short',
	        key: 'event_table_header_state_start',
	        render: (text, record) => {
	            return (
	            <Popover
					key={`popup_over_start_${record.station_uuid}_${record.mchs_uuid}`}                              
					placement="topLeft"
					content={record.start_start_full}
					trigger="hover"
				>
					<span className="text-uppercase">{text}</span>
				</Popover>
	            )
            }

	    },

	    {
	        title: 'Конечное',
	        dataIndex: 'state_finish_short',
	        key: 'event_table_header_state_finish',
	        render: (text, record) => {
	            return (
	            <Popover
					key={`popup_over_finish_${record.station_uuid}_${record.mchs_uuid}`}                              
					placement="topLeft"
					content={record.state_finish_full}
					trigger="hover"
				>
					<span className="text-uppercase">{text}</span>
				</Popover>
	            )
            }
	    },
	    {
	        title: 'Уровень опасности',
	        dataIndex: 'danger_level_short',
	        key: 'event_table_header_danger',
	        render: (text, record) => {
	            let color = record.danger_level.color;
	            return (
	            <Popover
					key={`popup_over_danger_${record.station_uuid}_${record.mchs_uuid}`}                              
					placement="topLeft"
					content={record.danger_level_full}
					trigger="hover"

				>
	                    <Tag color={color}>
                        <span className="text-uppercase">{text}</span>
	                    </Tag>
				</Popover>
	            )
            }

	    },
	    {
	        title: 'Значение',
	        dataIndex: 'value',
	        key: 'event_table_header_value'
	    },
	    {
	        title: 'Дата/Время',
	        dataIndex: 'state_change_date',
	        key: 'event_table_header_change_date'
	    } 
	]    

	const dangerOptions = getDangersList();	
	const mchsTypesOptions = getMchsList([station.station]);	

    return (
        <div className="mt-1 pos-relative">
			{!loaded && 
				<div className="loading loading-wrapper"></div>
			}

			<div>
				<DatePicker
					showTime={{
						format: 'HH:00'
					}}
					value={start}
					format="DD.MM.YYYY HH:00"
					onChange={onStartOk}
					onOk={onStartOk}
					locale={locale}
					changeOnBlur
					inputReadOnly
					allowClear={false}
					style={{width: 200}}
				/>

				<DatePicker
					showTime={{
						format: 'HH:00'
					}}
					value={finish}
					format="DD.MM.YYYY HH:00"
					onChange={onFinishOk}
					onOk={onFinishOk}
					locale={locale}
					changeOnBlur
					inputReadOnly
					className="ml-2"
					allowClear={false}
					style={{width: 200}}
				/>					
				<Button className="ml-1" type="default" shape="circle" icon={<ReloadOutlined />} onClick={onShowEventBtnClick} />					
			</div>
			<div className="mt-1">
				<Select
					mode="tags"
					placeholder="Уровень опасности"
					value={selectedDangers}
					showSearch={false}						
					style={{width:200}}
					allowClear
					onChange={onChangeSelectedDangers}
					options={dangerOptions.map(item => {
						return {
							'label': item.short,
							'value': item.code
						}	
					})}							
				/>
				<Select
					mode="tags"
					placeholder="Изм. канал"
					value={selectedMchsTypes}
					showSearch={false}						
					style={{width:200}}
					allowClear						
					className="ml-2"
					onChange={onChangeSelectedMchsTypes}
					options={mchsTypesOptions.map(item => {
						return {
							'label': item.name,
							'value': item.code
						}	
					})}							
				/>	                					
			</div>
			<div className="mt-1">
				<Space>
					<Radio.Group 
						size="small"
						block 
						options={escaladeOptions} 
						defaultValue={defEscaladeOption} 
						onChange={onChangeFilterEscalade} 
						optionType="button"
					/>
					<Popover
						placement="bottom"
						content={References.dictionary.event_no_data}
					>
					<Checkbox size="small" onChange={onChangeFilterNODATA}>НЕТ ДАННЫХ</Checkbox>					
					</Popover>
				</Space>
			</div>
			<div className="pos-relative">
			{expired && 
					<div className="expired-wrapper"></div>
			}
            <Table
                columns={columns}
                dataSource={eventsData(events)}
                pagination={false}
                size="small"
				className={`mt-2 dark-table-header`}
				scroll={{
					y: containerHeight - CONTAINER_OTHER_ELEMS_HEIGHT
				}}
				locale={References.dictionary.table}
            />
			</div>
        </div>
    )
}